export default __webpack_public_path__ + "static/media/pathname_model_zip.ea16a13a.gif";